/*eslint-env jquery*/
import React, { Component, useState } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { driversService } from '../../_services/drivers.service'
import { FaPlus } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import DriverFormDialog from './DriverFormDialog'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from "react-table"
import "react-table/react-table.css"
import { Input } from 'antd'
import { Tabs, Tab } from 'react-bootstrap'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

export class DataTable extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      initialItems: [],
      data: [],
      formDialog: false,
      formDialogHeading: '',
      id: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      activeTab: 'material',
      model: { name: '', mobile: '', bankId: '' }
    }

    this.getData()
  }

  handleModalCreate = () => {
    this.setState({ formDialogHeading: 'ثبت راننده جدید', formDialog: true, model: { name: '', name: '', mobile: '', bankId: '' } });
  }

  handleModalEdit = (_model) => {
    this.setState({ formDialog: true, model: _model, formDialogHeading: 'ویرایش راننده "' + _model.name + '"' });
  }

  handleModalHide = (e) => {
    var evt = e || window.event; // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault();
    }
    this.setState({ formDialog: false });
  }

  handleModalHideAndReload = (e) => {
    this.getData()
    this.setState({ formDialog: false });
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  getData() {
    driversService.getAll()
      .then((res) => {
        console.log(res.data)
        this.setState({ data: res.data, loading: false, isSubmitting: false, formDialog: false });
      })
      .catch((error) => {
        this.handleError(error)
      });
  };


  handleError(error) {
    this.setState({ loading: false });
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = (_model) => {
    this.setState({ confirmDeleteShow: true, model: _model });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });

    driversService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف راننده', 'راننده با موفقیت حذف شد');
        this.getData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }



  render() {

    const { model, loading } = this.state;
    return (
      <div>

        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            data={this.state.data}
            filterable
            loading={loading}
            previousText='صفحه قبل'
            nextText='صفحه بعد'
            loadingText='در حال بارگذاری ...'
            noDataText='نتیجه ای یافت نشد'
            pageText='صفحه'
            ofText='از'
            rowsText='تعداد نمایش'

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: "ردیف",
                id: "row",
                maxWidth: 50,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                Cell: (row) => {
                  return row.index + 1;
                }
              },
              {
                Header: "نام و نام خانوادگی راننده",
                accessor: "name",
                id: "name",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["name"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "موبایل راننده",
                accessor: "mobile",
                id: "mobile",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["mobile"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "ویرایش",
                accessor: 'id',
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                sortable: false,
                // filterable: false,
                Filter: ({ filter, onChange }) =>
                  <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn" >
                    <span>
                      <FaPlus size="16px" />
                      افزودن راننده جدید
                    </span>
                  </a>,
                Cell: row => (
                  <div>
                    <a onClick={() => this.handleModalEdit(row.original)} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a>

                    <a onClick={() => this.handleDelete(row.original)} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a>
                  </div>
                )
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />

        </div>

        <DriverFormDialog show={this.state.formDialog} id={model.id}
          handleModalHide={() => this.handleModalHide()}
          handleModalHideAndReload={() => this.handleModalHideAndReload()}
        />

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={"آیا از حذف راننده [" + this.state.model.name + "] مطمئن هستید؟"}
        >
        </MySweetAlert>

      </div >
    );
  }
}


const Drivers = props => {
  const [activeTab, setActiveTab] = useState('list')

  return (

    <Tabs transition={false}
      id="controlled-tab-example"
      activeKey={activeTab}
      onSelect={activeTab => setActiveTab(activeTab)}
    >
      <Tab eventKey="list" title="مدیریت راننده ها">
        {activeTab === 'list' ?
          <DataTable clientType={0} />
          : ''}
      </Tab>
    </Tabs>
  )
}
export default Drivers;